import axios from "../../../util/axios";

const PREFIX_URI = "/basedata/crm/person/dashboard";

/**
 * 工作台接口
 *
 * 工作台是独立业务页面，统计、审批、日历都走自己的工作台 Controller，
 * 不复用客户概况 / 商机漏斗 / 我的待办页面的接口。
 */
export default {
    /** 工作台总览：KPI、业务助理、客户/商机漏斗、业务审批 */
    overview: () => axios.get({url: `${PREFIX_URI}/overview`}),
    /** 工作台日历：某月有日程的日期与放假调休 */
    calendar: (data) => axios.get({url: `${PREFIX_URI}/calendar`, data}),
}
